<dx-toolbar @changes [width]="162" class="field-editor-map-toolbar">
  <dxi-item location="before" locateInMenu="never">
    <div *dxTemplate>
      <div class="relative">
        <dx-button
          id="changes"
          icon="save"
          stylingMode="text"
          text="Changements">
        </dx-button>
        <span class="button-badge">10</span>
      </div>
    </div>
  </dxi-item>
</dx-toolbar>


<dx-popover
  class="field-editor-changes-popover"
  [width]="400"
  showEvent="dxclick"
  [showTitle]="true"
  target="#changes"
  [elementAttr]="{class: 'field-editor-changes-popover'}"
  position="bottom"
  title="Changements"
  [showCloseButton]="true"
  [closeOnOutsideClick]="true">
  <div *dxTemplate="let model of 'content'"></div>
</dx-popover>
